// extracted by mini-css-extract-plugin
export var cardIcon = "_53-4";
export var checkboxCard = "_53-0";
export var checkboxCardSelected = "_53-3";
export var disabled = "_53-1";
export var outerBorder = "_53-2";
export var spacerMedium = "_53-7";
export var spacerSmall = "_53-6";
export var spacerXsmall = "_53-5";